import {io} from 'socket.io-client';

//http://socket.smarttips.bet/
//https://socket-betbuilder.onrender.com
export const socket = io('https://socket-betbuilder.onrender.com', {
    autoConnect: false,
})